
import React, { useState } from "react";

import CashVoucherGenerator from "./CashVoucherGenerator";
import GeneratedVouchers from "./GeneratedVouchers";

const CashVoucherManagement = () => {
  const [activeTab, setActiveTab] = useState("generation");

  const tabStyle = (tab) => ({
    border: "none",
    padding: "8px 18px",
    borderRadius: "8px",
    background:
      activeTab === tab ? "#0d6efd" : "transparent",
    color:
      activeTab === tab ? "#fff" : "#495057",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "0.2s ease",
    whiteSpace: "nowrap"
  });

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="filter cm-content-box box-primary">

          {/* HEADER WITH CENTER TABS */}
          <div className="content-title d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">

            <div className="cpa">
              <i className="fa fa-file-text-o me-2" />
              Cash Voucher Management
            </div>

            <div
              className="d-flex align-items-center flex-nowrap"
              style={{
                background: "#f1f3f5",
                padding: "5px",
                borderRadius: "12px",
                border: "1px solid #dee2e6"
              }}
            >
              <button
                type="button"
                onClick={() => setActiveTab("generation")}
                style={tabStyle("generation")}
              >
              Generate New Cash Voucher
              </button>

              <button
                type="button"
                onClick={() => setActiveTab("generated")}
                className="ms-2"
                style={tabStyle("generated")}
              >
                Cash Voucher List
              </button>
            </div>

            {/* Keeps tabs visually centered */}
            <div
              className="d-none d-md-block"
              style={{ width: "190px" }}
            />
          </div>

          {/* TAB CONTENT */}
          <div className="cm-content-body">
            {activeTab === "generation" ? (
              <CashVoucherGenerator />
            ) : (
              <GeneratedVouchers />
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default CashVoucherManagement;
